import { z } from 'zod'
import { AssigneeTypeEnum } from '@omnea-app/packages/universal/hasura/graphql'

export const AssigneeEntitySchema = z.object({
  type: z.nativeEnum(AssigneeTypeEnum),
  value: z.string(),
  id: z.string(),
  name: z.string().optional(),
  email: z.string().optional(),
  title: z.string().optional().nullable(),
  isOutOfOffice: z.boolean().optional(),
  isArchived: z.boolean().optional(),
})

export type AssigneeEntity = z.infer<typeof AssigneeEntitySchema>
